// extracted by mini-css-extract-plugin
module.exports = {"body":"SiteEditHost_body__tf4f8","points":"SiteEditHost_points__VtlNO","footer":"SiteEditHost_footer__6t1a6","sheet":"SiteEditHost_sheet__YIvBv"};